import React from "react";
import { SvgIcon, useTheme } from "@mui/material";

export const CreateTicketingIntegrationFirstStepIcon = ({ ...props }) => {
  const theme = useTheme();

  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 208 144" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M88 5C88 2.79086 89.7909 1 92 1H188C190.209 1 192 2.79086 192 5V101C192 103.209 190.209 105 188 105H92C89.7909 105 88 103.209 88 101V5Z"
          fill={theme.palette.background.light}
        />
        <path
          d="M88 5C88 2.79086 89.7909 1 92 1H188C190.209 1 192 2.79086 192 5V101C192 103.209 190.209 105 188 105H92C89.7909 105 88 103.209 88 101V5Z"
          stroke={theme.palette.background.lightest}
          strokeWidth="2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M157.067 35.0869L166.887 54.9663C167.323 55.8552 167.366 56.8637 167.016 57.7952C166.691 58.6414 166.076 59.3336 165.272 59.7268L135.077 74.6406C134.59 74.8799 134.069 74.9995 133.53 74.9995C133.282 74.9995 133.034 74.9739 132.787 74.9226C131.701 74.6919 130.804 74.0081 130.317 73.0253L120.497 53.1374L120.249 52.6246C119.83 51.7784 119.762 50.8127 120.069 49.9153C120.377 49.0179 121.009 48.2914 121.864 47.8726L152.059 32.9588C153.82 32.0871 155.948 32.8135 156.82 34.5741L157.067 35.0869ZM122.522 49.2059C122.035 49.4538 121.667 49.8725 121.488 50.3939C121.308 50.9152 121.343 51.4708 121.591 51.9665L121.685 52.163L143.846 57.573C144.889 57.8294 145.965 57.2995 146.393 56.3167L155.572 35.4202L155.478 35.2237C155.23 34.7365 154.811 34.369 154.29 34.1895C153.768 34.0101 153.213 34.0442 152.717 34.2921L122.522 49.2059ZM134.043 73.4441C134.171 73.4099 134.299 73.3586 134.419 73.2988L164.614 58.3935C164.819 58.2909 164.999 58.1457 165.161 57.9833L151.991 54.1886C151.589 54.0775 151.367 53.6672 151.478 53.2655C151.589 52.8639 151.999 52.6416 152.401 52.7528L165.751 56.5987C165.768 56.2654 165.7 55.9321 165.546 55.633L156.435 37.1808L147.76 56.9235C147.153 58.291 145.812 59.1371 144.367 59.1371C144.077 59.1371 143.786 59.0943 143.487 59.026L122.548 53.9151L131.667 72.3757C131.855 72.7518 132.154 73.0509 132.522 73.2475L137.607 60.2481C137.752 59.8635 138.188 59.6755 138.573 59.8208C138.957 59.9661 139.154 60.402 139 60.7866L134.043 73.4441ZM114.604 63.6909C114.493 63.7421 114.382 63.7678 114.271 63.7678C113.989 63.7678 113.724 63.6139 113.595 63.349C113.416 62.9815 113.57 62.5285 113.937 62.349L120.296 59.2124C120.663 59.033 121.116 59.1868 121.296 59.5543C121.475 59.9218 121.322 60.3748 120.954 60.5543L114.604 63.6909ZM119.533 64.8324C119.901 64.6529 120.354 64.8067 120.533 65.1742C120.713 65.5503 120.559 65.9947 120.191 66.1827L113.841 69.3193C113.73 69.3706 113.619 69.3963 113.508 69.3963C113.226 69.3963 112.961 69.2424 112.833 68.9775C112.653 68.61 112.807 68.157 113.183 67.969L119.533 64.8324ZM124.455 67.6519L118.105 70.7885C117.738 70.968 117.584 71.421 117.763 71.7885C117.891 72.0534 118.156 72.2072 118.438 72.2072C118.55 72.2072 118.661 72.1816 118.772 72.1303L125.122 68.9937C125.489 68.8142 125.643 68.3613 125.464 67.9938C125.276 67.6177 124.823 67.4724 124.455 67.6519Z"
          fill="currentColor"
        />
        <path
          d="M8 29C8 26.7909 9.79086 25 12 25H108C110.209 25 112 26.7909 112 29V125C112 127.209 110.209 129 108 129H12C9.79086 129 8 127.209 8 125V29Z"
          fill={theme.palette.background.light}
        />
        <path
          d="M8 29C8 26.7909 9.79086 25 12 25H108C110.209 25 112 26.7909 112 29V125C112 127.209 110.209 129 108 129H12C9.79086 129 8 127.209 8 125V29Z"
          stroke={theme.palette.background.lightest}
          strokeWidth="2"
        />
        <path
          d="M86.5143 75.4323L62.4158 51.3338L60.0803 49L33.648 75.4323C32.784 76.2987 32.784 77.7013 33.648 78.566L50.2212 95.1386L60.0803 105L86.5143 78.566C87.379 77.7013 87.379 76.2987 86.5143 75.4323ZM60.0803 85.2772L51.8028 77.0003L60.0803 68.7204L68.3595 77.0003L60.0803 85.2772Z"
          fill="#2684FF"
        />
        <path
          d="M60.0816 68.7182C54.6624 63.2966 54.6347 54.5159 60.0239 49.0625L41.9062 67.1731L51.7677 77.0345L60.0816 68.7182Z"
          fill="url(#paint0_linear_3126_107727)"
        />
        <path
          d="M68.3803 76.9766L60.0781 85.277C62.6945 87.8909 64.166 91.439 64.166 95.1384C64.166 98.8377 62.6945 102.383 60.0781 105L78.2394 86.838L68.3803 76.9766Z"
          fill="url(#paint1_linear_3126_107727)"
        />
        <circle
          cx="192"
          cy="120"
          r="16"
          fill="url(#paint2_linear_3126_107727)"
        />
        <path
          d="M193.266 114.602V126H191.016V117.195L188.312 118.055V116.281L193.023 114.602H193.266Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3126_107727"
            x1="56.5235"
            y1="62.4248"
            x2="47.0433"
            y2="71.9026"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0052CC" />
            <stop offset="1" stopColor="#2684FF" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_3126_107727"
            x1="63.7386"
            y1="91.4805"
            x2="73.1998"
            y2="82.0193"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0052CC" />
            <stop offset="1" stopColor="#2684FF" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_3126_107727"
            x1="176"
            y1="104"
            x2="208.789"
            y2="135.17"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9147FF" />
            <stop offset="1" stopColor="#4C35E8" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
};
